import React from 'react';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
const maxListPage = 6;
const colorStatus = {
  danger: {
    range: {
      max: 0,
      min: 0,
    },
    color: 'danger',
  },
  warning: {
    range: {
      max: 99,
      min: 1,
    },
    color: 'warning',
  },
  success: {
    range: {
      max: 1000,
      min: 100,
    },
    color: 'success',
  },
};
const Works = ({ listObrasPublicas }) => {
  const theme = useTheme();
  return (
    <Box>
      <Box />
      <Typography
        variant="h4"
        align={'center'}
        gutterBottom
        margin={10}
        sx={{
          fontWeight: 700,
          marginTop: theme.spacing(1),
        }}
      >
        Estado de Obras en 2021
        <br/>
      </Typography>
      <div className="container-table">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th className='col-2' >Nombre de comunidad</th>
                <th className='col-3' >Descripción de la obra publica</th>
                <th className='col-2' >Acta de aprobación</th>
                <th className='col-2' >Contrato de Obra publico</th>
                <th className='col-3' >Estimaciones</th>
                <th className='col-2' >Linea de Tiempo</th>
              </tr>
            </thead>
            <tbody>
              {listObrasPublicas.map((obras, index) => (
                <tr key={index}>
                  <td>{obras.nameComunidad}</td>
                  <td>{obras.description}</td>
                  <td>
                    {tags(obras.actaAproved.status, obras.actaAproved.link)}
                  </td>
                  <td>
                    {tags(obras.contratoPublic.status, obras.contratoPublic.link)}
                  </td>
                  <td>
                    {tags(obras.Estimaciones.status, obras.Estimaciones.link)}
                  </td>
                  <td>
                    <div className="progress-data">
                      <div className="text-progress-data">
                        {obras.lineTime}%
                      </div>
                      <div
                        style={{ width: obras.lineTime + '%' }}
                        className={
                          'progress-' + colorBarProgress(obras.lineTime)
                        }
                      ></div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {pieFooter(listObrasPublicas.length)}
      </div>
    </Box>
  );
};
const pieFooter = (size) => {
  let buttons = [];
  if (size > maxListPage) {
    const sizeFull = Math.round(size / maxListPage);
    for (let index = 0; index < sizeFull; index++) {
      buttons.push(
        <button key={index} className="btn btn-info">
          {index + 1}
        </button>,
      );
    }
    return (
      <div className="page-pie">
        <button className="btn">
          <i className="fas fa-angle-left"></i>
        </button>
        {buttons}
        <button className="btn">
          <i className="fas fa-angle-right"></i>
        </button>
      </div>
    );
  }
};

const tags = (status, link) => {
  const statusTag = typeStatus(status);
  return (
    <div onClick={() => openLinkPagenFile(link)} className={statusTag.color}>
      <i className={statusTag.icon}></i>
      {statusTag.description}
    </div>
  );
};

const typeStatus = (status) => {
  const StatusObject = {
    A: {
      description: 'Aprovado',
      color: 'tag tag-' + colorStatus.success.color,
      icon: 'fas fa-exclamation-triangle',
    },
    C: {
      description: 'Cancelado',
      color: 'tag tag-' + colorStatus.danger.color,
      icon: 'fas fa-check',
    },
    P: {
      description: 'Progreso',
      color: 'tag tag-' + colorStatus.warning.color,
      icon: 'fas fa-spinner',
    },
  };
  return StatusObject[status];
};

const colorBarProgress = (numberProgress) => {
  if (
    numberProgress >= colorStatus.danger.range.min &&
    numberProgress < colorStatus.danger.range.max
  ) {
    return colorStatus.danger.color;
  }
  if (
    numberProgress >= colorStatus.warning.range.min &&
    numberProgress < colorStatus.warning.range.max
  ) {
    return colorStatus.warning.color;
  }
  if (
    numberProgress >= colorStatus.success.range.min &&
    numberProgress < colorStatus.success.range.max
  ) {
    return colorStatus.success.color;
  }
};

const openLinkPagenFile = (link) => {
  if (link != '') {
    window.open(link, '_blank');
  }
};
export default Works;
